import React from 'react';

export default function Typography(props){
    const Component = props.component || 'div';

    return <Component {...props}>{props.children}</Component>
}